var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6338 14.1162C25.1225 14.6049 25.1225 15.395 24.6338 15.8838L15.8838 24.6338C15.64 24.8775 15.32 25 15 25C14.68 25 14.3599 24.8775 14.1162 24.6338L5.3662 15.8838C4.87745 15.395 4.87745 14.6049 5.3662 14.1162C5.85495 13.6274 6.64502 13.6274 7.13377 14.1162L15 21.9824L22.8662 14.1162C23.3549 13.6274 24.145 13.6274 24.6338 14.1162ZM14.1162 15.8838C14.3599 16.1275 14.68 16.25 15 16.25C15.32 16.25 15.64 16.1275 15.8838 15.8838L24.6338 7.13377C25.1225 6.64502 25.1225 5.85495 24.6338 5.3662C24.145 4.87745 23.3549 4.87745 22.8662 5.3662L15 13.2324L7.13377 5.3662C6.64502 4.87745 5.85495 4.87745 5.3662 5.3662C4.87745 5.85495 4.87745 6.64502 5.3662 7.13377L14.1162 15.8838Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.eca96e03707ab51211f7d19887b48a6d.svg";
export { ForwardRef as ReactComponent };